import { render, staticRenderFns } from "./ComboboxMunicipioTerritoriosByTerritorios.vue?vue&type=template&id=3b9820f5"
import script from "./ComboboxMunicipioTerritoriosByTerritorios.vue?vue&type=script&lang=js"
export * from "./ComboboxMunicipioTerritoriosByTerritorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports